import { FC, SVGProps } from "react";
import { useMirrorTransform } from "src/i18n/direction";

type PlaneProgressProps = SVGProps<SVGSVGElement> & { mirrorInRtl?: boolean };

const PlaneProgress: FC<PlaneProgressProps> = ({ transform, mirrorInRtl, ...props }) => {
  const mirroredTransform = useMirrorTransform(transform as string | undefined);
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentcolor" transform={mirroredTransform} {...props}>
      <path
        d="M0 5H2.5L4.6 8H8.2L5 0H8L13.6 8H18C18.55 8 19.0208 8.19583 19.4125 8.5875C19.8042 8.97917 20 9.45 20 10C20 10.55 19.8042 11.0208 19.4125 11.4125C19.0208 11.8042 18.55 12 18 12H13.6L8 20H5L8.2 12H4.6L2.5 15H0L1.5 10L0 5Z"
      />
    </svg>
  );
};

export default PlaneProgress;
